"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _preact = require("preact");
var _SearchFilterInput = _interopRequireDefault(require("../SearchFilterInput.js"));
var _Browser = _interopRequireDefault(require("../Browser.js"));
var _CloseWrapper = _interopRequireDefault(require("../CloseWrapper.js"));
var _View2 = _interopRequireDefault(require("../View.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }
  return receiver;
}
var id = 0;
function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
var packageJson = {
  "version": "3.13.0"
};
var defaultState = {
  isInputMode: true,
  files: [],
  folders: [],
  breadcrumbs: [],
  filterInput: '',
  currentSelection: [],
  searchTerm: null
};
var defaultOptions = {
  viewType: 'grid',
  showTitles: true,
  showFilter: true,
  showBreadcrumbs: true
};
var _updateFilesAndInputMode = /*#__PURE__*/_classPrivateFieldLooseKey("updateFilesAndInputMode");
/**
 * SearchProviderView, used for Unsplash and future image search providers.
 * Extends generic View, shared with regular providers like Google Drive and Instagram.
 */
var SearchProviderView = exports.default = /*#__PURE__*/function (_View) {
  function SearchProviderView(plugin, opts) {
    var _this2;
    _classCallCheck(this, SearchProviderView);
    _this2 = _callSuper(this, SearchProviderView, [plugin, _objectSpread(_objectSpread({}, defaultOptions), opts)]);
    Object.defineProperty(_this2, _updateFilesAndInputMode, {
      value: _updateFilesAndInputMode2
    });
    _this2.nextPageQuery = null;
    _this2.search = _this2.search.bind(_this2);
    _this2.clearSearch = _this2.clearSearch.bind(_this2);
    _this2.resetPluginState = _this2.resetPluginState.bind(_this2);
    _this2.handleScroll = _this2.handleScroll.bind(_this2);
    _this2.donePicking = _this2.donePicking.bind(_this2);
    _this2.render = _this2.render.bind(_this2);
    _this2.plugin.setPluginState(defaultState);
    _this2.registerRequestClient();
    return _this2;
  }

  // eslint-disable-next-line class-methods-use-this
  _inherits(SearchProviderView, _View);
  return _createClass(SearchProviderView, [{
    key: "tearDown",
    value: function tearDown() {
      // Nothing.
    }
  }, {
    key: "resetPluginState",
    value: function resetPluginState() {
      this.plugin.setPluginState(defaultState);
    }
  }, {
    key: "search",
    value: function () {
      var _search = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(query) {
        var _this$plugin$getPlugi, searchTerm, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _this$plugin$getPlugi = this.plugin.getPluginState(), searchTerm = _this$plugin$getPlugi.searchTerm;
              if (!(query && query === searchTerm)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.setLoading(true);
              _context.p = 2;
              _context.n = 3;
              return this.provider.search(query);
            case 3:
              res = _context.v;
              _classPrivateFieldLooseBase(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](res, []);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.handleError(_t);
            case 5:
              _context.p = 5;
              this.setLoading(false);
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function search(_x) {
        return _search.apply(this, arguments);
      }
      return search;
    }()
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      this.plugin.setPluginState({
        currentSelection: [],
        files: [],
        searchTerm: null
      });
    }
  }, {
    key: "handleScroll",
    value: function () {
      var _handleScroll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(event) {
        var query, _this$plugin$getPlugi2, files, searchTerm, response, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              query = this.nextPageQuery || null;
              if (!(this.shouldHandleScroll(event) && query)) {
                _context2.n = 5;
                break;
              }
              this.isHandlingScroll = true;
              _context2.p = 1;
              _this$plugin$getPlugi2 = this.plugin.getPluginState(), files = _this$plugin$getPlugi2.files, searchTerm = _this$plugin$getPlugi2.searchTerm;
              _context2.n = 2;
              return this.provider.search(searchTerm, query);
            case 2:
              response = _context2.v;
              _classPrivateFieldLooseBase(this, _updateFilesAndInputMode)[_updateFilesAndInputMode](response, files);
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.handleError(_t2);
            case 4:
              _context2.p = 4;
              this.isHandlingScroll = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function handleScroll(_x2) {
        return _handleScroll.apply(this, arguments);
      }
      return handleScroll;
    }()
  }, {
    key: "donePicking",
    value: function donePicking() {
      var _this3 = this;
      var _this$plugin$getPlugi3 = this.plugin.getPluginState(),
        currentSelection = _this$plugin$getPlugi3.currentSelection;
      this.plugin.uppy.log('Adding remote search provider files');
      this.plugin.uppy.addFiles(currentSelection.map(function (file) {
        return _this3.getTagFile(file);
      }));
      this.resetPluginState();
    }
  }, {
    key: "render",
    value: function render(state, viewOptions) {
      var _this = this;
      if (viewOptions === void 0) {
        viewOptions = {};
      }
      var _this$plugin$getPlugi4 = this.plugin.getPluginState(),
        didFirstRender = _this$plugin$getPlugi4.didFirstRender,
        isInputMode = _this$plugin$getPlugi4.isInputMode,
        searchTerm = _this$plugin$getPlugi4.searchTerm;
      var i18n = this.plugin.uppy.i18n;
      if (!didFirstRender) {
        this.preFirstRender();
      }
      var targetViewOptions = _objectSpread(_objectSpread({}, this.opts), viewOptions);
      var _this$plugin$getPlugi5 = this.plugin.getPluginState(),
        files = _this$plugin$getPlugi5.files,
        folders = _this$plugin$getPlugi5.folders,
        filterInput = _this$plugin$getPlugi5.filterInput,
        loading = _this$plugin$getPlugi5.loading,
        currentSelection = _this$plugin$getPlugi5.currentSelection;
      var isChecked = this.isChecked,
        filterItems = this.filterItems,
        recordShiftKeyPress = this.recordShiftKeyPress;
      var hasInput = filterInput !== '';
      var browserProps = {
        isChecked: isChecked,
        toggleCheckbox: this.toggleCheckbox.bind(this),
        recordShiftKeyPress: recordShiftKeyPress,
        currentSelection: currentSelection,
        files: hasInput ? filterItems(files) : files,
        folders: hasInput ? filterItems(folders) : folders,
        handleScroll: this.handleScroll,
        done: this.donePicking,
        cancel: this.cancelPicking,
        // For SearchFilterInput component
        showSearchFilter: targetViewOptions.showFilter,
        search: this.search,
        clearSearch: this.clearSearch,
        searchTerm: searchTerm,
        searchOnInput: false,
        searchInputLabel: i18n('search'),
        clearSearchLabel: i18n('resetSearch'),
        noResultsLabel: i18n('noSearchResults'),
        title: this.plugin.title,
        viewType: targetViewOptions.viewType,
        showTitles: targetViewOptions.showTitles,
        showFilter: targetViewOptions.showFilter,
        isLoading: loading,
        showBreadcrumbs: targetViewOptions.showBreadcrumbs,
        pluginIcon: this.plugin.icon,
        i18n: i18n,
        uppyFiles: this.plugin.uppy.getFiles(),
        validateRestrictions: function validateRestrictions() {
          var _this$plugin$uppy;
          return (_this$plugin$uppy = _this.plugin.uppy).validateRestrictions.apply(_this$plugin$uppy, arguments);
        }
      };
      if (isInputMode) {
        return (0, _preact.h)(_CloseWrapper.default, {
          onUnmount: this.resetPluginState
        }, (0, _preact.h)("div", {
          className: "uppy-SearchProvider"
        }, (0, _preact.h)(_SearchFilterInput.default, {
          search: this.search,
          inputLabel: i18n('enterTextToSearch'),
          buttonLabel: i18n('searchImages'),
          inputClassName: "uppy-c-textInput uppy-SearchProvider-input",
          buttonCSSClassName: "uppy-SearchProvider-searchButton",
          showButton: true
        })));
      }
      return (0, _preact.h)(_CloseWrapper.default, {
        onUnmount: this.resetPluginState
      }, (0, _preact.h)(_Browser.default, browserProps));
    }
  }]);
}(_View2.default);
function _updateFilesAndInputMode2(res, files) {
  this.nextPageQuery = res.nextPageQuery;
  res.items.forEach(function (item) {
    files.push(item);
  });
  this.plugin.setPluginState({
    currentSelection: [],
    isInputMode: false,
    files: files,
    searchTerm: res.searchedFor
  });
}
SearchProviderView.VERSION = packageJson.version;